import { render, staticRenderFns } from "./white-label-preview.vue?vue&type=template&id=1c6e0ab0&scoped=true&"
import script from "./white-label-preview.vue?vue&type=script&lang=js&"
export * from "./white-label-preview.vue?vue&type=script&lang=js&"
import style0 from "./white-label-preview.vue?vue&type=style&index=0&id=1c6e0ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6e0ab0",
  null
  
)

export default component.exports